/**
 * Wishlist (PDP) helper.
 *
 * The wishlist button is injected by the Wishlist Hero app inside the product
 * form. Force type="button" on the injected button so clicking the heart never
 * submits the form (i.e. never accidentally adds the product to the cart).
 */
(function () {
  'use strict';

  function fixWishlistButtonType() {
    document.querySelectorAll('.wishlist-hero-pdp button').forEach(function (btn) {
      if (btn.getAttribute('type') !== 'button') {
        btn.setAttribute('type', 'button');
      }
    });
  }

  function init() {
    // The app injects its button asynchronously, so re-check a few times.
    [0, 300, 800, 1500, 3000].forEach(function (delay) {
      setTimeout(fixWishlistButtonType, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
